export default {
  savePageAsDefault: 'Startseite setzen',
  resetDefaultPage: 'Startseite zurücksetzen',
  bugReport: 'Bug/Fehler melden',
};
